import React, { useCallback, useEffect, useState } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import appSettings from '../../constants/app.constants';
import './container.scss';
import LeftBlockContainer from './containers/leftBlockContainer/LeftBlockContainer';
import FileView from './containers/fileView/FileView.jsx';
import NoticeView from './containers/NoticeView/NoticeView';
import getNoticeStates from './store/thunks/getNoticeStates';
import { useDispatch, useSelector } from 'react-redux';
import getDebtorStates from './store/thunks/getDebtorStates';
import useSetRefreshFn from '../../hooks/useSetRefreshFn.js';
import getDebtsList from './store/thunks/getDebtsList.js';
import getNoticesList from './store/thunks/getNoticesList.js';
import HeaderDebts from './components/HeaderDebts/HeaderDebts.jsx';
import useCompanies from '../../queries/useCompanies.js';
import { Alert, Icon, Spin, Tooltip } from 'antd';
import { setAlertUrl, setCurrentCompany } from './store/actions/actions.js';
import { useLocation, useHistory } from 'react-router-dom';
import { downloadFile } from './constants/fileCache.js';

const DebtsContainer = () => {
  const dispatch = useDispatch();

  const location = useLocation();
  const history = useHistory();

  const { data: companies, isFetching: isCompaniesFetching } = useCompanies({
    staleTime: Infinity,
  });

  const currentCompany = useSelector(
    (state) => state.debtsStore.currentCompany
  );
  const urlError = useSelector((state) => state.debtsStore.alertUrl);

  const { fileId, fileName, message } = urlError || {};

  const currentCompanyId = currentCompany?.id;

  const handleCloseAlert = () => {
    dispatch(setAlertUrl(null));
  };

  const fileMatch = useRouteMatch('/Debts/file/:fileId');
  const noticeMatch = useRouteMatch('/Debts/file/:fileId/notice/:noticeId');

  const listener = useCallback(() => {
    setHeight(window.innerHeight - appSettings.windowHeightDelta);
  }, [window.innerHeight, appSettings.windowHeightDelta]);
  const [height, setHeight] = useState(0);

  const styleContainer = {
    height: height,
    overflowY: 'auto',
    overflowX: 'hidden',
  };

  useEffect(() => {
    setHeight(window.innerHeight - appSettings.windowHeightDelta);
    window.addEventListener('resize', listener);

    return () => {
      window.removeEventListener('resize', listener);
    };
  }, []);

  useEffect(() => {
    dispatch(getNoticeStates());
    dispatch(getDebtorStates());
  }, []);

  useSetRefreshFn(() => {
    dispatch(getNoticeStates());
    dispatch(getDebtorStates());

    if (fileMatch?.params?.fileId) {
      dispatch(getDebtsList({ fileId: fileMatch.params.fileId }));
    }

    if (noticeMatch?.params?.noticeId) {
      dispatch(getNoticesList(noticeMatch.params.noticeId));
    }
  }, [fileMatch?.params?.fileId]);

  useEffect(() => {
    if (!companies?.length) return;

    const params = new URLSearchParams(location.search);
    const companyIdFromUrl = params.get('companyId');

    if (companyIdFromUrl) {
      if (currentCompanyId !== Number(companyIdFromUrl)) {
        const companyFromUrl = companies.find(
          (c) => c.id === Number(companyIdFromUrl)
        );
        if (companyFromUrl) {
          dispatch(setCurrentCompany(companyFromUrl));
        }
      }
      return;
    }

    if (!currentCompanyId) {
      const defaultCompany = companies[0];
      dispatch(setCurrentCompany(defaultCompany));

      params.set('companyId', defaultCompany.id);
      history.replace({
        pathname: location.pathname,
        search: params.toString(),
      });
      return;
    }

    params.set('companyId', currentCompanyId);
    history.replace({
      pathname: location.pathname,
      search: params.toString(),
    });
  }, [
    dispatch,
    history,
    companies,
    currentCompanyId,
    location.pathname,
    location.search,
  ]);

  useEffect(() => {
    if (!companies?.length) return;

    const params = new URLSearchParams(location.search);
    const companyIdFromUrl = params.get('companyId');

    if (!companyIdFromUrl) return;

    if (currentCompanyId === Number(companyIdFromUrl)) return;

    const companyFromUrl = companies.find(
      (c) => c.id === Number(companyIdFromUrl)
    );

    if (companyFromUrl) {
      dispatch(setCurrentCompany(companyFromUrl));
    }
  }, [dispatch, currentCompanyId, companies, location.search]);

  return (
    <div>
      {isCompaniesFetching ? (
        <Spin />
      ) : (
        <>
          <HeaderDebts />
          {Boolean(fileId) && (
            <Alert
              message={
                <div
                  style={{
                    display: 'flex',
                    gap: 10,
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <div>{message}</div>
                  <Tooltip title="Скачать файл с ошибками">
                    <Icon
                      type="download"
                      onClick={() => downloadFile(fileId, fileName)}
                      style={{ fontSize: 20, color: '#0995ED' }}
                    />
                  </Tooltip>
                </div>
              }
              type="info"
              showIcon
              closable
              onClose={handleCloseAlert}
            />
          )}

          <div className="Debts__container">
            <div className="Debts__left-block">
              <LeftBlockContainer height={height} />
            </div>
            <div
              className="Debts__right-block"
              style={styleContainer}
            >
              <Switch>
                <Route path="/Debts/file/:fileId/notice/:noticeId">
                  <NoticeView />
                </Route>
                <Route path="/Debts/file/:fileId">
                  <FileView />
                </Route>
              </Switch>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default DebtsContainer;
